import * as React from 'react';

export const EmailBoxSvg = (props: any) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='52'
			height='52'
			fill='none'
			viewBox='0 0 52 52'
			{...props}
		>
			<circle cx='26' cy='26' r='26' fill='#F0F0F0'></circle>
			<path
				stroke='#444'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M20.667 20.667h10.666c.734 0 1.334.6 1.334 1.333v8c0 .733-.6 1.333-1.334 1.333H20.667c-.734 0-1.334-.6-1.334-1.333v-8c0-.733.6-1.333 1.334-1.333z'
			></path>
			<path
				stroke='#444'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M32.667 22L26 26.667 19.333 22'
			></path>
		</svg>
	);
};
